import { useQuery } from "@tanstack/react-query";
import type { ProductType } from "../models/ProductType";
import { getProductTypes } from "../repositories/ProductTypesRepository";

export const PRODUCT_TYPES_QUERY_KEYS = {
	all: ["productTypes"] as const,
	list: () => ["productTypes", "list"] as const,
	byId: (id: number | null) => ["productTypes", "detail", id] as const,
};

export const useProductTypes = () => {
	const query = useQuery<ProductType[], Error>({
		queryKey: PRODUCT_TYPES_QUERY_KEYS.list(),
		queryFn: () => getProductTypes(),
	});

	return {
		productTypes: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
